import { useCreateOrUpdateTirageInBibliography } from "@/api/related-fields";
import { FieldConfig } from "@/config/forms/general";
import { TirageInBibliography } from "@/lib/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import LinksDrawerLayout from "./LinksDrawerLayout";

const TirageInBibliographyDrawer = ({
  fields,
  data,
  queryId,
  type,
}: {
  fields: FieldConfig[] | undefined;
  data: TirageInBibliography;
  queryId: string;
  type: string;
}) => {
  const schema = z.object({
    tirageDansBibliographieDescriptionReproduitPage: z.string().optional(),
    tirageDansBibliographieDescriptionCitePage: z.string().optional(),
    tirageDansBibliographieDescriptionPhotographe: z.string().optional(),
    tirageDansBibliographieDescriptionReproductionCouleur: z
      .boolean()
      .optional(),
    tirageDansBibliographieDescriptionNonPagine: z.boolean().optional(),
    tirageDansBibliographieNotes: z.string().optional(),
    bibliography: z.object({
      bibliographieDescriptionNumeroBibliographie: z.string().optional(),
      bibliographieDescriptionResumeLong: z.string().optional(),
    }),
  });

  const { mutate: createOrUpdateTirageInBibliography } =
    useCreateOrUpdateTirageInBibliography(queryId, type);

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: {
      bibliography: data.bibliography,
      tirageDansBibliographieDescriptionReproduitPage:
        data.tirageDansBibliographieDescriptionReproduitPage,
      tirageDansBibliographieDescriptionCitePage:
        data.tirageDansBibliographieDescriptionCitePage,
      tirageDansBibliographieDescriptionPhotographe:
        data.tirageDansBibliographieDescriptionPhotographe,
      tirageDansBibliographieDescriptionReproductionCouleur:
        data.tirageDansBibliographieDescriptionReproductionCouleur,
      tirageDansBibliographieDescriptionNonPagine:
        data.tirageDansBibliographieDescriptionNonPagine,
      tirageDansBibliographieNotes: data.tirageDansBibliographieNotes,
    },
  });

  const onSubmit = (formData: z.infer<typeof schema>) => {
    createOrUpdateTirageInBibliography({
      id: data.id,
      tirageId: data.tirage.id,
      bibliographyId: data.bibliography.id,
      ...formData,
    });
  };

  return (
    <LinksDrawerLayout
      form={form}
      fields={fields ?? []}
      recordId={data.id}
      onSubmit={onSubmit}
    />
  );
};

export default TirageInBibliographyDrawer;
